<template>
  <div class="text-center">
    <v-dialog v-model="show" width="550">
      <CustomNotification
        :show-notification="showCustomNotification"
        :notification-type="savingStatus.type"
      >
        <span class="body-2 cms_">{{ savingStatus.msg }}</span>
      </CustomNotification>
      <v-card>
        <v-card-title class="justify-left">
          <h1 class="headline primary--text text--accent-2">
            {{ title }}
            <v-icon
              class="pt-3 pr-3"
              style="right: 0px; top: 0px; position: absolute"
              color="primary"
              medium
              @click="closeDialog"
              >mdi-close</v-icon
            >
          </h1>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-1 pb-1">
          <v-row>
            <v-col cols="3">
              <h4>{{ $cmsService.getContent(content, 'rule') }}</h4>
            </v-col>
            <v-col>
              <v-text-field
                v-if="ruleObject.rule === ''"
                id="ruleName"
                v-model="ruleName"
                :label="'Regelname'"
                :error-messages="ruleNameError"
                dense
                required
                @input="$v.ruleName.$touch()"
              ></v-text-field>
              <span
                v-if="ruleObject.rule !== ''"
                class="primary--text text--accent-2"
              >
                {{ ruleObject.rule }}
              </span>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="3">
              <h4>{{ $cmsService.getContent(content, 'letter_type') }}</h4>
            </v-col>
            <v-col>
              <span class="primary--text text--accent-2">
                {{ getEnumsContent('LetterType', ruleObject.letterType) }}
              </span>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col class="pb-0" cols="3">
              <h4>{{ $cmsService.getContent(content, 'lead_region') }}</h4>
            </v-col>
            <v-col class="pb-0" cols="2">
              <h4>{{ $cmsService.getContent(content, 'from') }}</h4>
            </v-col>
            <v-col class="pb-0" cols="2">
              <h4>{{ $cmsService.getContent(content, 'to') }}</h4>
            </v-col>
            <v-col class="pb-0">
              <h4>{{ $cmsService.getContent(content, 'excluded') }}</h4>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0" offset="3" cols="2">
              <span class="primary--text text--accent-2">
                {{ ruleObject.regionFrom }}
              </span>
            </v-col>
            <v-col class="pt-0" cols="2">
              <span class="primary--text text--accent-2">
                {{ ruleObject.regionTo }}
              </span>
            </v-col>
            <v-col class="pt-0">
              <span v-if="ruleObject.regionExclude.length === 0">
                <span class="primary--text text--accent-2">
                  {{ $cmsService.getContent(content, 'no') }}
                </span>
              </span>
              <span v-if="ruleObject.regionExclude.length > 0">
                <span
                  v-for="(excludedRegion, index) in ruleObject.regionExclude"
                  :key="excludedRegion"
                  class="primary--text text--accent-2"
                >
                  <span v-if="index != 0">{{ ',' }} </span
                  >{{ excludedRegion }}</span
                >
              </span>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="3">
              <h4>{{ $cmsService.getContent(content, 'folder_type') }}</h4>
            </v-col>
            <v-col>
              <span class="primary--text text--accent-2">
                {{ getEnumsContent('FoldType', ruleObject.foldType) }}
              </span>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="3">
              <h4>{{ $cmsService.getContent(content, 'paper_type') }}</h4>
            </v-col>
            <v-col>
              <span class="primary--text text--accent-2">
                {{ getEnumsContent('PaperType', ruleObject.paperType) }}
              </span>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="3">
              <h4>{{ $cmsService.getContent(content, 'cover_type') }}</h4>
            </v-col>
            <v-col>
              <span class="primary--text text--accent-2">
                {{ getEnumsContent('CoverType', ruleObject.coverType) }}
              </span>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="3">
              <h4>{{ $cmsService.getContent(content, 'print_mode') }}</h4>
            </v-col>
            <v-col>
              <span class="primary--text text--accent-2">
                {{ getEnumsContent('PrintMode', ruleObject.printMode) }}
              </span>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="3">
              <h4>{{ $cmsService.getContent(content, 'color') }}</h4>
            </v-col>
            <v-col>
              <span class="primary--text text--accent-2">
                {{ getEnumsContent('ColorMode', ruleObject.colorMode) }}
              </span>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="3">
              <h4>{{ $cmsService.getContent(content, 'franking_type') }}</h4>
            </v-col>
            <v-col>
              <span class="primary--text text--accent-2">
                {{ getEnumsContent('FrankingType', ruleObject.frankingType) }}
              </span>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="4">
              <v-checkbox
                v-model="ruleObject.hasOnlyFullBatches"
                :label="$cmsService.getContent(content, 'full_batches')"
                color="primary"
                hide-details
                disabled
              ></v-checkbox>
            </v-col>
            <v-col cols="4">
              <v-checkbox
                v-model="ruleObject.isRialtoCapable"
                :label="$cmsService.getContent(content, 'rialto_capabale')"
                color="primary"
                hide-details
                disabled
              ></v-checkbox>
            </v-col>
            <v-col cols="4">
              <v-checkbox
                v-model="ruleObject.isWithSupplement"
                :label="$cmsService.getContent(content, 'supplement')"
                color="primary"
                hide-details
                disabled
              ></v-checkbox>
            </v-col>
            <v-col cols="4">
              <v-checkbox
                v-model="ruleObject.isWithInternational"
                :label="
                  $cmsService.getContent(content, 'international_letters')
                "
                color="primary"
                hide-details
                disabled
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider class="py-1"></v-divider>
        <v-card-actions class="pr-3 pb-3">
          <v-btn
            color="grey"
            class="white--text text-capitalize"
            @click="closeDialog"
            ><span>{{ $cmsService.getContent(content, 'cancel') }}</span></v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="white--text text-capitalize"
            @click="triggerSaveOrUpdate"
            ><span>{{ button }}</span></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { rulesService } from '@/services/'
import { required, minLength } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { mapActions } from 'vuex'
import CustomNotification from '@/components/CustomNotification'
import { EnumBaseMixin } from '@/enums/EnumBaseMixin'
import ruleConfirmationDialogJson from '@/data/json/dialogs/ruleConfirmationDialog.json'
import enumsJson from '@/data/json/enums/enums.json'
export default {
  name: 'RuleConfirmationDialog',
  components: {
    CustomNotification
  },
  mixins: [validationMixin, EnumBaseMixin],
  validations: {
    ruleName: {
      required,
      minLength: minLength(3)
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    ruleObject: {
      type: Object
    },
    title: {
      type: String,
      default: ''
    },
    dialogContent: {
      type: String,
      default: ''
    },
    button: {
      type: String,
      default: ''
    },
    ruleRequestbody: {
      type: Object
    },
    ruleNameProp: {
      type: String,
      default: ''
    },
    getContent: {
      type: Function
    },
    updateRulesNameList: {
      type: Function
    }
  },
  data: () => ({
    enumsContent: enumsJson.data,
    content: ruleConfirmationDialogJson.data,
    ruleName: '',
    showCustomNotification: false,
    savingStatus: {},
    submitError: false
  }),
  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    ruleNameError() {
      const errors = []
      if (!this.$v.ruleName.$dirty) return errors
      !this.$v.ruleName.minLength &&
        errors.push(this.getContent('field_min_length'))
      !this.$v.ruleName.required &&
        errors.push(this.getContent('field_required'))
      return errors
    }
  },
  methods: {
    ...mapActions(['fetchRules']),
    triggerSaveOrUpdate: function () {
      this.showNotification = false
      this.$v.$touch()
      if (this.$v.$invalid && this.ruleObject.rule === '') {
        //if validation incorrect and no rule has been selected from select box
        this.submitError = true
      } else {
        // if validation is correct
        if (this.ruleName === '' && this.ruleObject.rule !== '') {
          // validation correct and existing rule has not been selected from selectbox
          // then update existing rule
          this.ruleRequestbody.ruleName = this.ruleObject.rule
          this.ruleRequestbody.id = this.ruleObject.id
          this.updateRule()
        } else {
          // validation correct and saved rule is a new rule
          // then save new rule
          this.ruleRequestbody.ruleName = this.ruleName
          this.saveRule()
        }
      }
    },
    closeDialog: function () {
      this.show = false
    },
    saveRule: async function () {
      await rulesService
        .saveRule(this.ruleRequestbody)
        .then(response => {
          this.fetchRules().then(() => {
            // reload because of async vuex store
            this.updateRulesNameList()
            this.$emit('updateRulesNameList')
            window.location.reload()
          })
          this.closeDialog()
          return response
        })
        .catch(e => {
          this.showNotification = true
          const msg = this.getError(e.response.status)
          this.savingStatus = {
            type: 'error',
            msg: msg
          }
        })
    },
    updateRule: async function () {
      await rulesService
        .updateRule(this.ruleRequestbody)
        .then(response => {
          this.fetchRules().then(() => {
            this.$emit('updateRulesNameList')
            this.$emit('saved')
          })
          this.closeDialog()
          return response
        })
        .catch(e => {
          this.showNotification = true
          const msg = this.getError(e.response.status)
          this.savingStatus = {
            type: 'error',
            msg: msg
          }
        })
    },
    getError: function (errorKey) {
      return this.$store.getters.error({
        errorKey: errorKey,
        route: this.$route.name
      })
    }
  }
}
</script>
